import React from 'react'
import FooterImage1 from '../../assets/image1.png' // Replace with actual images
import FooterImage2 from '../../assets/image2.png' // Replace with actual images
import FooterImage3 from '../../assets/image3.png' // Replace with actual images
import step1_1 from '../../assets/step1_1.png'
import step1_2_1 from '../../assets/step1_2_1.png'
import step1_2 from '../../assets/step1_2.png'
import step1_3 from '../../assets/step1_3.png'
import step1_4 from '../../assets/step1_4.png'
import step1_5 from '../../assets/step1_5.png'
import step1_6 from '../../assets/step1_6.png'
import step1_7 from '../../assets/step1_7.png'
import step1_8 from '../../assets/step1_8.png'
import step2_1 from '../../assets/step2_1.png'
import step2_2 from '../../assets/step2_2.png'
import step2_3 from '../../assets/step2_3.png'
import step2_4 from '../../assets/step2_4.png'
import step2_5 from '../../assets/step2_5.png'
import step2_6 from '../../assets/step2_6.png'
import step2_7 from '../../assets/step2_7.png'
import step2_8 from '../../assets/step2_8.png'
import step2_9 from '../../assets/step2_9.png'
import step2_10 from '../../assets/step2_10.png'
import step2_11 from '../../assets/step2_11.png'
import step2_12 from '../../assets/step2_12.png'
import step2_13 from '../../assets/step2_13.png'
import step2_14 from '../../assets/step2_14.png'
import step3_1 from '../../assets/step3_1.png'
import step3_2 from '../../assets/step3_2.png'
import step3_3 from '../../assets/step3_3.png'
import step3_4 from '../../assets/step3_4.png'
import step3_5 from '../../assets/step3_5.png'


import { useNavigate } from 'react-router-dom'
import ZynthWorks,{Slide} from './ZynthWorks'

const slides1: Slide[] = [
  {
    imageUrl: step1_1,
    dotPosition: { top: "39%", left: "33%" },
    caption: "1. Click on Text Box and Enter your presentation context",
  },
  {
    imageUrl:step1_2,
    dotPosition: { top: "65%", left: "40%" },
    caption:"2. OR upload a document."
  },
  {
    imageUrl:step1_2_1 ,
    dotPosition: { top: "80%", left: "51%" },
    caption: '3. Click "Submit" to view presentation options.',
    
  },
  {
    imageUrl: step1_3,
    dotPosition: { top: "23%", left: "30%" },
    caption: '4. Enter your "Reference Web URL"',
  },
  {
    imageUrl: step1_4,
    dotPosition: { top: "40%", left: "70%" },
    caption: '5. Select "Branding Colors" for the presentation.',
  },
  {
    imageUrl: step1_5,
    dotPosition: { top: "60%", left: "60%" },
    caption: '6.Save changes after picking colours.',
    
  },
  {
    imageUrl: step1_6,
    dotPosition: { top: "58%", left: "30%" },
    caption: '7. Choose a "Theme" of your presentation.',
  },
  {
    imageUrl: step1_7,
    dotPosition: { top: "78%", left: "50%" },
    caption: '8. Adjust "Creativity" based on your requirements.',
  },
  {
    imageUrl: step1_8,
    dotPosition: { top: "89%", left: "50%" },
    caption: '9. Click on "Generate Presentation"',
  
  },
];


const slides2: Slide[] = [
  {
    imageUrl: step2_1,
    dotPosition: { top: "40%", left: "70%" },
    caption: "1. View the generated presentation.",
    show:false
  },
  {
    imageUrl: step2_2,
    dotPosition: { top: "50%", left: "11%" },
    caption: "2. Add new sections to the outline.",
   
  },
  {
    imageUrl: step2_3,
    dotPosition: { top: "52%", left: "10%" },
    caption: '3. Enter the title for the new outline.',
  },
  {
    imageUrl: step2_4,
    dotPosition: { top: "93%", left: "48%" },
    caption: '4. Create new versions for the slides.',
  },
  {
    imageUrl: step2_5,
    dotPosition: { top: "58%", left: "37%" },
    caption: '5. Click on "Quick Generate" to create a new version without any input.',
    
  },
  {
    imageUrl: step2_6,
    dotPosition: { top: "50%", left: "50%" },
    caption: '6. A new slide is quickly generated!',
    show:false
  },
  {
    imageUrl: step2_7,
    dotPosition: { top: "52%", left: "60%" },
    caption: '7. Select "Slide Narrative" to generate a slide with provided context.',
  },
  {
    imageUrl: step2_8,
    dotPosition: { top: "28%", left: "40%" },
    caption: "8. Select the dropdown to choose the type of the slide.",   
  },
  {
    imageUrl: step2_9,
    dotPosition: { top: "50%", left: "50%" },
    caption: "9. Enter additional context for the slide.",
     
  },
  {
    imageUrl: step2_10,
    dotPosition: { top: "40%", left: "70%" },
    caption: '10. A newly narrated slide is generated!',
    show:false
    
  },
  {
    imageUrl: step2_11,
    dotPosition: { top: "52%", left: "83%" },
    caption: '11. Select "Custom Builder" to control the structure of the slide.',
  },
  {
    imageUrl: step2_12,
    dotPosition: { top: "45%", left: "35%" },
    caption: '12. Select a slide type based on your preference.',
  },
  {
    imageUrl: step2_13,
    dotPosition: { top: "60%", left: "50%" },
    caption: '13. Provide the text and image input in the given structure.',
    
  },
  {
    imageUrl: step2_14,
    dotPosition: { top: "60%", left: "25%" },
    caption: "14. A new customized slide is built.",
    show:false
  },

];

const slides3: Slide[] =[

  {
    imageUrl: step3_1,
    dotPosition: { top: "12%", left: "82%" },
    caption: '1. Finalize slides and click on the "Share" button.',
    
  },
  {
    imageUrl: step3_2,
    dotPosition: { top: "50%", left: "11%" },
    caption: "2. This will create a public weblink for your presentation!",
    show:false
  },
  {
    imageUrl: step3_3,
    dotPosition: { top: "12%", left: "30%" },
    caption: '3. Click on "Edit on Google Slides" or "Download PowerPoint" to export the presentation.',
  },
  {
    imageUrl: step3_4,
    dotPosition: { top: "93%", left: "48%" },
    caption: '4. Seamlessly make edits on the Google Slides version of the presentation.',
    show:false
  },
  {
    imageUrl: step3_5,
    dotPosition: { top: "58%", left: "37%" },
    caption: '5. Or make final changes on the downloaded PowerPoint presentation.',
     show:false
    
  },
  
];

const HowWorks: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="bg-[#F0F6FF]">
      {/* How Zynth Works Section */}
      <section  id="how-it-works" className="py-16 px-4 lg:px-24">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">
          How Zynth Works?
        </h2>
        <div className="space-y-16">
          {/* Step 1 */}
          <div className="flex flex-col lg:flex-row items-center gap-8">
  <div className="lg:w-1/2 flex items-start gap-4">
    {/* White circular background for the number */}
    <div className="flex-shrink-0 flex items-center justify-center w-8  h-8 lg:w-14 lg:h-14 bg-white text-blue-600 text-2xl font-bold rounded-full shadow-md">
      1
    </div>
    <div>
      <h3 className="text-2xl font-semibold text-gray-900">
       Provide Presentation Input and Customize Options
      </h3>
      <ul className="mt-4 text-black space-y-2 list-disc list-inside">
        <li>Use a prompt or upload a document to create a presentation.  </li>
        <li>Finalize the presentation’s outline and data sources. </li>
        <li>Customize your presentation’s branding and theme.</li>
      </ul>
      <button
        onClick={() => navigate('/auth')}
        className="mt-6 px-6 py-2 font-semibold bg-transparent border border-[#3667B2] text-[#3667B2] hover:text-white rounded-md hover:bg-[#3667B2] active:scale-95 active:opacity-80 transition-all duration-300"
      >
        Generate Presentation
      </button>
    </div>
  </div>
  <div className="lg:w-1/2">
    {/* <img
      src={FooterImage1}
      alt="AI Presentation Maker"
      className="w-full rounded-lg shadow-md"
    /> */}
    <div className="flex-1">
          <ZynthWorks slides={slides1}  bgColor="bg-[#3667B2]"/>
        </div>
  </div>
</div>

          {/* Step 2 */}
          <div className="flex flex-col lg:flex-row-reverse items-center gap-8">
            <div className="lg:w-1/2 flex items-start gap-4">
            <div className="flex-shrink-0 flex items-center justify-center w-8 h-8 lg:w-14 lg:h-14 bg-white text-blue-600 text-2xl font-bold rounded-full shadow-md">
      2
    </div>
              <div>
                <h3 className="text-2xl font-semibold text-gray-900">
                 View Presentation and Create New Slides
                </h3>
                <ul className="mt-4 text-black font-normal space-y-2 list-disc list-inside">
                  <li>
                   AI auto-generates layouts, sections, content and visuals. 
                  </li>
                  <li>
                    Add new slides to your presentation outline with a click.
                  </li>
                  <li>
                   Create new versions of slides across slide types.
                  </li>
                </ul>
                <button
                  onClick={() => navigate('/auth')}
                  className="mt-6 px-6 py-2 bg-transparent font-semibold border border-[#3667B2] text-[#3667B2] hover:text-white rounded-md hover:bg-[#3667B2] active:scale-95 active:opacity-80 transition-all duration-300"
                >
                 Create Slides
                </button>
              </div>
            </div>
            <div className="lg:w-1/2">
              {/* <img
                src={FooterImage2}
                alt="Customizable Slide Designs"
                className="w-full rounded-lg shadow-md"
              /> */}
              <div className="flex-1">
          <ZynthWorks slides={slides2}  bgColor="bg-[#3667B2]" />
        </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="lg:w-1/2 flex items-start gap-4">
            <div className="flex-shrink-0 flex items-center justify-center w-8 h-8 lg:w-14 lg:h-14 bg-white text-blue-600 text-2xl font-bold rounded-full shadow-md">
      3
    </div>
              <div>
                <h3 className="text-2xl font-semibold text-gray-900">
                 Share and Export the Generated Presentation
                </h3>
                <ul className="mt-4 text-black space-y-2 list-disc list-inside">
                  <li>Share your AI presentation instantly via weblinks</li>
                  <li>Download your presentation as an editable Powerpoint.</li>
                  <li>
                    Sync seamlessly by exporting to Google Slides for final edits.
                  </li>
                </ul>
                <button
                  onClick={() => navigate('/auth')}
                  className="mt-6 px-6 py-2 bg-transparent font-semibold border border-[#3667B2] text-[#3667B2] hover:text-white rounded-md hover:bg-[#3667B2] active:scale-95 active:opacity-80 transition-all duration-300"
                >
                  Share Presentation
                </button>
              </div>
            </div>
            <div className="lg:w-1/2">
              <div className="flex-1">
          <ZynthWorks slides={slides3}  bgColor="bg-[#3667B2]" />
        </div>
            </div>
          </div>
        </div>
      </section>
    </div>

/* <div className="w-full px-4 md:px-12 py-10">
     <div className='flex items-center justify-center w-full'>
       <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">
        How Zynth Works?
        </h2>
     </div>
      <div className="flex flex-col md:flex-row gap-8 justify-center items-stretch">
        <div className="flex-1">
          <ZynthWorks slides={slides1}  bgColor="bg-[#3667B2]" />
        </div>
        <div className="flex-1">
          <ZynthWorks slides={slides2}  bgColor="bg-[#7DFFE0]"/>
        </div>
        <div className="flex-1">
          <ZynthWorks slides={slides3}  bgColor="bg-[#0A8568]" />
        </div>
      </div>
    </div> */


  )
}

export default HowWorks
